import { render, staticRenderFns } from "./Bounces.vue?vue&type=template&id=2e18e644&"
import script from "./Bounces.vue?vue&type=script&lang=ts&"
export * from "./Bounces.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports